import AppConstants from '../constants/AppConstants';

export const initialState = {
    last: {
        data: [],
        parameters: {},
        loading: false,
        error: null
    },
    today: {
        data: [],
        parameters: {},
        loading: false,
        error: null
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.DASHBOARD_LAST_START_LOADING:
            return {
                ...state,
                last: {
                    ...state.last,
                    loading: true
                }
            };

        case AppConstants.DASHBOARD_LAST_SUCCESS:
            return {
                ...state,
                last: {
                    parameters: action.items.parameters,
                    data: _addTotals(action.items.rows, action.items.totals),
                    loading: false
                }
            };

        case AppConstants.DASHBOARD_LAST_FAIL:
            return {
                ...state,
                last: {
                    ...state.last,
                    loading: false,
                    error: action.error
                }
            };

        case AppConstants.DASHBOARD_TODAY_START_LOADING:
            return {
                ...state,
                today: {
                    ...state.today,
                    loading: true
                }
            };

        case AppConstants.DASHBOARD_TODAY_SUCCESS:
            return {
                ...state,
                today: {
                    parameters: action.items.parameters,
                    data: action.items.rows,
                    loading: false
                }
            };

        case AppConstants.DASHBOARD_TODAY_FAIL:
            return {
                ...state,
                today: {
                    ...state.today,
                    loading: false,
                    error: action.error
                }
            };

        case AppConstants.DASHBOARD_CLEAR:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};

const _addTotals = (list, totals) => {
    if (!list || !list.length) {
        return list || [];
    }

    return [
        ...list,
        totals
    ];
};
